// components/LoginRedirectHandler.tsx
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../utils/msalConfig";

const LoginRedirectHandler: React.FC = () => {
  const { instance } = useMsal();

  useEffect(() => {
    instance.loginRedirect(loginRequest).catch((error) => {
      console.error("Auto-login failed:", error);
    });
  }, [instance]);

  return null; // No UI needed
};

export default LoginRedirectHandler;